import React from 'react';
import { 
  HelpCircle, 
  Car, 
  Clock, 
  Coffee, 
  FileText, 
  Shield, 
  Map, 
  Fuel 
} from 'lucide-react';

/**
 * Компонент боковой панели с полезными советами
 */
const TipsSidebar = () => {
  const tips = [
    {
      icon: Car,
      title: 'Проверка ТС',
      description: 'Проведите технический осмотр автомобиля перед дальней поездкой.'
    },
    {
      icon: Clock,
      title: 'Выбор времени',
      description: 'Выезжайте рано утром, чтобы избежать пробок в крупных городах.'
    },
    {
      icon: Coffee,
      title: 'Регулярные остановки',
      description: 'Делайте перерыв каждые 2-3 часа для отдыха и восстановления внимания.'
    },
    {
      icon: FileText,
      title: 'Документы',
      description: 'Проверьте наличие всех необходимых документов и их срок действия.'
    },
    {
      icon: Shield,
      title: 'Безопасность',
      description: 'Возьмите аптечку, огнетушитель и знак аварийной остановки.'
    },
    {
      icon: Map,
      title: 'Маршрут',
      description: 'Изучите маршрут заранее, отметьте АЗС и места для отдыха.'
    },
    {
      icon: Fuel,
      title: 'Топливо',
      description: 'Заправляйтесь заблаговременно, не дожидаясь критического уровня.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-blue-500" />
        Советы путешественникам
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <Clock className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Режим труда и отдыха
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400 mb-3">
              По правилам дорожного движения, водителям рекомендуется делать перерыв 
              каждые 2-3 часа вождения продолжительностью не менее 15 минут.
            </p>
            <a 
              href="https://www.gibdd.ru/mens/drivers/rezhim-truda-i-otdyha-voditeley/" 
              target="_blank"
              rel="noopener noreferrer"
              className="w-full py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors text-center block"
            >
              Подробнее о правилах
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;